import React from 'react';

const InputFeedback = ({ error }) =>
  error ? (
    <div className="input-feedback">{error}</div>
  ) : null;

const Label = ({
  error,
  className,
  children,
  ...props
}) => {
  return (
    <label className="label" {...props}>
      {children}
    </label>
  );
};

const RadioButton = ({
  name,
  value,
  onChange,
  onBlur,
  id,
  label,
  error,
  className,
  ...props
}) => {
  return (
    <div className="option">
      <input
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      <Label htmlFor={id}>{label}</Label>
      <InputFeedback error={error} />
    </div>
  );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/RadioButton.js